var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center"},[_c('b-card-title',[(!_vm.loading)?_c('big',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.value))]):_c('layout-loading'),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }